/** Human-readable cycle duration from total months. */
export function formatCycleDurationLabel(months: number): string {
  const m = Math.max(1, Math.trunc(months));
  if (m % 12 === 0) return `${m / 12}yr`;
  if (m < 12) return `${m}mo`;
  return `${Math.floor(m / 12)}yr ${m % 12}mo`;
}

export function resolveDisplayedCycleMonths(row: {
  expiry_months?: number | null;
  expiry_years?: number | null;
}): number {
  const months = Number(row.expiry_months);
  if (Number.isInteger(months) && months >= 1) return months;
  const years = Number(row.expiry_years);
  if (Number.isFinite(years) && years >= 1) return Math.trunc(years) * 12;
  return 24;
}
